import _ from 'lodash'

import { cloudhelpPost, cloudhelpGet } from 'Utilities/CloudHelp'

const isBlankValidation = (attribute, humanName) => {
  if (_.isNil(attribute)) {
    return { failed: true, message: `${humanName} cannot be blank.\n` }
  }
  return { failed: false }
}

const isBlankValidationForText = (attribute, humanName) => {
  if (_.isEmpty(attribute)) {
    return { failed: true, message: `${humanName} cannot be blank.\n` }
  }
  return { failed: false }
}

const validateConversion = (fields) => {
  const {
    queueId,
    title,
    description,
    ticketId,
    contactId,
    problemLinkType
  } = fields

  const fieldsToValidate = [
    {
      attribute: queueId,
      type: 'string',
      humanName: 'Queue',
      validations: [isBlankValidation]
    },
    {
      attribute: title,
      type: 'string',
      humanName: 'Title',
      validations: problemLinkType ? [isBlankValidationForText] : []
    },
    {
      attribute: description,
      type: 'string',
      humanName: 'Description',
      validations: problemLinkType ? [isBlankValidationForText] : []
    },
    {
      attribute: contactId,
      type: 'string',
      humanName: 'Contact',
      validations: [isBlankValidation]
    }
  ]

  if (problemLinkType === 'merge') {
    fieldsToValidate.push(
      {
        attribute: ticketId,
        type: 'string',
        humanName: 'Ticket',
        validations: [isBlankValidation]
      }
    )
  }
  const errors = []
  _.each(fieldsToValidate, (field) => {
    const { validations } = field

    _.each(validations, (validationFunction) => {
      const validation = validationFunction(field.attribute, field.humanName)

      if (!_.isNil(validation) && validation.failed) { errors.push(validation.message) }
    })
  })

  return errors
}

// eslint-disable-next-line import/prefer-default-export
export const handlers = {
  bind (component) {
    const handlerFunctions = [
      'setModal',
      'handleFieldValue',
      'rejectAlerts',
      'toggleProblemStatus',
      'setTitleAndDescription',
      'convertAlerts',
      'getTickets',
      'handleAssignToMe',
      'handleQueue'
    ]

    _.each(handlerFunctions, (handlerFunction) => {
      this[handlerFunction] = this[handlerFunction].bind(component)
    })

    return this
  },

  setModal (modal) {
    this.setState({ modal })
  },

  handleFieldValue (field, value) {
    this.setState((prevState) => {
      const { fields } = prevState

      const newValue = (value) => {
        if (value === null) { return value }

        return typeof value === 'object' ? value.value : value
      }

      const newFields = Object.assign({}, fields, { [field]: newValue(value) })

      return { fields: newFields }
    })
  },

  rejectAlerts () {
    const { selectedAlerts, rejectAlertsEndpoint } = this.state

    if (!window.confirm('Are you sure to reject selected alerts?')) {
      return
    }

    this.setState({
      loading: true,
      alertMessage: { alertText: '', alertType: '' }
    })

    cloudhelpPost(rejectAlertsEndpoint, { ids: _.flatMap(selectedAlerts, alert => (alert.previous_alerts_ids.split(','))) })
      .then(() => {
        // TODO: When Tim has finished working with RemoteTable hooks, reload data instead of reloading page
        this.setState({
          loading: false,
          modal: null,
          selectedAlerts: [],
          alertMessage: {
            alertText: 'successfully rejected',
            alertType: 'success'
          }
        })

        window.location.reload(true)
      })
  },

  toggleProblemStatus (problemLinkType) {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign(
        {},
        fields,
        {
          issue: '', priority: null, bulkMessage: '', problemId: null
        }
      )

      return { problemLinkType, fields: newFields }
    })
  },

  setTitleAndDescription () {
    this.setState((prevState) => {
      const { ownTitleAndDescription } = prevState

      return { ownTitleAndDescription: !ownTitleAndDescription }
    })
  },

  convertAlerts () {
    const {
      convertAlertsEndpoint
    } = this.props
    const {
      problemLinkType,
      ownTitleAndDescription,
      selectedAlerts, fields: {
        assigneeId,
        queueId,
        problemId,
        issue,
        priority,
        bulkMessage,
        contactId,
        ticketId,
        title,
        description,
        disabledContactNotifications
      }
    } = this.state

    const toValidate = {
      queueId,
      title,
      description,
      ticketId,
      contactId,
      problemLinkType
    }

    const errors = validateConversion(toValidate)

    if (_.isEmpty(errors)) {
      this.setState({
        loading: true,
        alertMessage: { alertText: '', alertType: '' }
      })

      const postData = {
        ids: _.map(selectedAlerts, alert => alert.id),
        ticket: {
          assignee_user_id: assigneeId,
          queue_id: queueId,
          client_contact_id: contactId,
          title,
          description,
          disabled_contact_notifications: disabledContactNotifications
        },
        problem: {
          issue,
          bulk_message: bulkMessage,
          priority
        },
        problem_id: problemId,
        ticket_id: ticketId,
        type_creation: problemLinkType,
        own_title_and_description: ownTitleAndDescription
      }

      cloudhelpPost(convertAlertsEndpoint, postData)
        .then(() => {
          // TODO: When Tim has finished working with RemoteTable hooks, reload data instead of reloading page
          this.setState({
            loading: false,
            modal: null,
            selectedAlerts: [],
            alertMessage: {
              alertText: 'successfully converted',
              alertType: 'success'
            }
          })

          window.location.reload(true)
        })
    } else {
      this.setState({ errors })
    }
  },

  getTickets (value) {
    if (value.length < 4) {
      return
    }

    this.setState({ loadingTickets: true })

    const params = {
      page_size: `1000`,
      page: `1`,
      filtered: [
        {
          subject: 'parent_status',
          type: 'is',
          value: 'current',
          text: 'Current'
        },
        { value }
      ]
    }

    cloudhelpGet('/tickets.json', { params }, { responseType: 'json' })
      .then(({ data }) => {
        const tickets = _.map(data.rows, ticket => (
          {
            label: `#${ticket.id.value} - ${ticket.title}`, value: ticket.id.value
          }
        ))

        this.setState({ ticketsForSelect: tickets, loadingTickets: false })
      })
  },

  handleAssignToMe (value) {
    const { currentUser } = this.props
    const valuesToHandle = [
      { key: 'assignToMe', val: value },
      { key: 'queueId', val: null },
      { key: 'assigneeId', val: value ? currentUser : null }
    ]

    _.each(valuesToHandle, (hash) => {
      this.handleFieldValue(hash.key, hash.val)
    })
  },

  handleQueue (e) {
    const { fields: { assignToMe } } = this.state

    this.handleFieldValue('queueId', e)
    if (!assignToMe) this.handleFieldValue('assigneeId', null)
  }
}
